import React from 'react'
import IconWrapper, { IconProps } from './IconWrapper'

export default function ChevronLeft({ ...props }: IconProps) {
    return (
        <IconWrapper {...props}>
            <svg
                width="16"
                height="16"
                viewBox="0 0 17 17"
                preserveAspectRatio="xMidYMid meet"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M10.5 3.16671L5.16667 8.50004L10.5 13.8334"
                    stroke="#fff"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </IconWrapper>
    )
}
